import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowForwardIos = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#1f1f1f",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" })
});
export default SvgArrowForwardIos;
